import { ASSETS } from '../const'

const TTBH_STEP = [
  {
    key: 'step_1',
    order: 1,
    stepImage: ASSETS.TTB_STEP_1,
    title: {
      disabledKey: 'TTBH_STEP_STEP_ONE_ORDER_TITLE_DISABLED',
      value: 'Order your items online',
    },
    contentBlock: [
      {
        body: {
          nonTTBHAllow: true,
          disabledKey: 'TTBH_STEP_STEP_ONE_ORDER_DETAIL_DISABLED',
          value: 'Choose multiple styles, sizes & colours from our Pomelo app.',
        },
      },
    ],
  },
  {
    key: 'step_2',
    order: 2,
    stepImage: ASSETS.TTB_STEP_2,
    title: {
      disabledKey: 'TTBH_STEP_STEP_TWO_LOCATION_TITLE_DISABLED',
      value: 'Send to any location',
    },
    contentBlock: [
      {
        subtitle: {
          key: 'TTBH_STEP_TRY_ON_SITE',
          value: 'Try at Pomelo Location',
        },
        body: {
          nonTTBHAllow: true,
          disabledKey: 'TTBH_STEP_STEP_TWO_LOCATION_OPTION_DETAIL_2_DISABLED',
          value: 'Try for free, at any Pomelo location.',
          locator: {
            key: 'TTBH_STEP_STORE_LOCATOR_TITLE',
            value: 'STORE LOCATOR',
          },
        },
      },
    ],
  },
  {
    key: 'step_3',
    order: 3,
    stepImage: ASSETS.TTB_STEP_3,
    title: {
      disabledKey: 'TTBH_STEP_STEP_THREE_LOCATION_TITLE_DISABLED',
      value: 'Pay for what you love',
    },
    contentBlock: [
      {
        subtitle: {
          key: 'TTBH_STEP_TRY_ON_SITE',
          value: 'Try at Pomelo Location',
        },
        body: {
          nonTTBHAllow: true,
          disabledKey: 'TTBH_STEP_STEP_THREE_PAYMENT_OPTION_DETAIL_2_DISABLED',
          value: 'No extra charge upfront!',
        },
      },
    ],
  },
]

export default TTBH_STEP
